"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Changes the ignoreSubsequentRules value in the inbox rule edit store
 * @param shouldIgnoreSubsequentRules value to set, sets the corresponding value for the inbox rule
 */
exports.default = legacy_1.action('setIgnoreSubsequentRules')(function setIgnoreSubsequentRules(shouldIgnoreSubsequentRules) {
    store_1.default.inboxRulesEditState.ignoreSubsequentRules = shouldIgnoreSubsequentRules;
});
//# sourceMappingURL=setIgnoreSubsequentRules.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/setIgnoreSubsequentRules.js
// module id = 5213
// module chunks = 2